import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
import xamatron from "xamatron";
var ContactRegionView = /** @class */ (function (_super) {
    tslib_1.__extends(ContactRegionView, _super);
    function ContactRegionView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.regionPath = null;
        _this.regionId = null;
        _this.region = null;
        return _this;
    }
    ContactRegionView.prototype.routed = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var parts, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.regionPath = params.regionPath;
                        parts = this.regionPath.split("/");
                        this.regionId = parseInt(parts[parts.length - 1], 10);
                        this.region = null;
                        return [4 /*yield*/, axios.get("dealers/regions/" + this.regionId)];
                    case 1:
                        data = (_a.sent()).data;
                        this.region = data;
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactRegionView.prototype.open = function (url) {
        xamatron.openURL(url);
    };
    ContactRegionView = tslib_1.__decorate([
        Component
    ], ContactRegionView);
    return ContactRegionView;
}(Vue));
export default ContactRegionView;
